export default __webpack_public_path__ + "static/Mergers-&-acquisitions-ddc50af28ffde57cf2f8ada3eaafea38.webp";